// extracted by mini-css-extract-plugin
export default {"grid":"WhyUs_grid__zVgEn","card":"WhyUs_card__CVhFx","title":"WhyUs_title__+7TQw","description":"WhyUs_description__Opk7F"};